<template>
  <div class="el-image">
      <image-viewer
        :z-index="zIndex"
        :initial-index="imageIndex"
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="previewSrcList"
      />
  </div>
</template>
<script>
import imageViewer from "element-ui/packages/image/src/image-viewer.vue";
let prevOverflow = ""
export default {
  components: {
    imageViewer,
  },
  props: {
    src: String,
    previewSrcList: {
      type: Array,
      default: () => [],
    },
    zIndex: {
      type: Number,
      default: 999999,
    },
  },
  data() {
    return {
      showViewer:false
    };
  },
  computed: {
    imageIndex() {
      let previewIndex = 0;
      const srcIndex = this.previewSrcList.indexOf(this.src);
      if (srcIndex >= 0) {
        previewIndex = srcIndex;
      }
      return previewIndex;
    },
  },
  methods: {
    clickHandler() {
        // don't show viewer when preview is false
        // prevent body scroll
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.showViewer = true;
      },
    closeViewer() {
      document.body.style.overflow = prevOverflow;
      this.showViewer = false;
    },
    
  },
};
</script>